<template>
  <div>
    <div
      v-show="showableSearchForm"
      class="item-index-cover"
      @click="hideSearchForm"
    />
    <transition name="slide">
      <SearchFormDetail
        v-if="showableSearchForm"
        :keyword="keyword"
        :higher-budget="higherBudget"
        :lower-budget="lowerBudget"
        :categories="categories"
        :scenes="scenes"
        :receiving-kinds="receivingKinds"
        :selected-category-ids="selectedCategoryIds"
        :selected-scene-ids="selectedSceneIds"
        :selected-receiving-kind-ids="selectedReceivingKindIds"
        @submit="onSubmit"
        @click-hide="hideSearchForm"
      />
    </transition>
  </div>
</template>
<script>
import SearchFormDetail from './SearchFormDetail.vue'
export default {
  components: {
    SearchFormDetail
  },
  props: {
    showableSearchForm: {
      type: Boolean,
      required: true
    },
    keyword: {
      type: String,
      require: true,
      default: ''
    },
    lowerBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    higherBudget: {
      required: true,
      validator: prop => typeof prop === 'number' || prop === null
    },
    categories: {
      type: Array,
      required: true
    },
    selectedCategoryIds: {
      type: Array,
      required: true
    },
    scenes: {
      type: Array,
      required: true
    },
    selectedSceneIds: {
      type: Array,
      required: true
    },
    receivingKinds: {
      type: Array,
      required: true
    },
    selectedReceivingKindIds: {
      type: Array,
      required: true
    }
  },
  methods: {
    hideSearchForm() {
      this.$emit('hide')
    },
    onSubmit(
      inputtedLowerBudget,
      inputtedHigherBudget,
      inputtedSelectedCategoryIds,
      inputtedSelectedSceneIds,
      inputtedReceivingKindIds
    ) {
      this.$emit(
        'submit',
        inputtedLowerBudget,
        inputtedHigherBudget,
        inputtedSelectedCategoryIds,
        inputtedSelectedSceneIds,
        inputtedReceivingKindIds
      )
    }
  }
}
</script>
